// src/init-modules.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import circleInfoIcon from "./assets/icon_circle-info-icon.svg";
import addDependentBanner from "./assets/add-dependent-banner_add-dependents.png";
import leagueFamilyEducationBanner from "./assets/league-family-education-banner_lf-education.png";
var DEPENDENTS_ASSETS = {
  CIRCLE_INFO_ICON: circleInfoIcon,
  ADD_DEPENDENT_BANNER: addDependentBanner,
  LEAGUE_FAMILY_EDUCATION_BANNER: leagueFamilyEducationBanner
};

// src/init-modules.ts
var initModule = () => {
  setDefaultAssets(DEPENDENTS_ASSETS);
};

// src/components/add-dependent-banner/add-dependent-banner.component.tsx
import React from "react";
import { LinkLegacy as RouteLink } from "@leagueplatform/routing";
import {
  Flex,
  Box,
  HeadingFour,
  BodyOne,
  Link,
  BackgroundImage
} from "@leagueplatform/genesis-commons";
import { useIntl } from "@leagueplatform/locales";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";
import { handleStaticAsset } from "@leagueplatform/asset-config";
var memberScreenerUrl = "/member/screener";
function learnMoreClick() {
  trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA.WALLET,
    screen_name: "dependents settings",
    detail: "QLE - learn more",
    link: memberScreenerUrl,
    text_detail: "QLE",
    text_sub_detail: "QLE - help"
  });
}
var AddDependentBanner = () => {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      as: "section",
      width: 1,
      marginBottom: "oneAndHalf",
      borderColor: "decorative.brand.primary.bright",
      borderStyle: "solid",
      borderWidth: "thin",
      borderRadius: "medium",
      backgroundColor: "highlight.background.subdued",
      overflow: "hidden"
    },
    /* @__PURE__ */ React.createElement(Box, { width: "65%", padding: "two" }, /* @__PURE__ */ React.createElement(HeadingFour, { marginBottom: "half", as: "h2" }, formatMessage({
      id: "HAVE_YOU_RECENTLY_EXPERIENCED_CHANGES"
    })), /* @__PURE__ */ React.createElement(BodyOne, { marginBottom: "oneAndHalf" }, formatMessage({ id: "DID_YOU_RECENTLY" })), /* @__PURE__ */ React.createElement(
      Link,
      {
        as: RouteLink,
        "aria-label": formatMessage({ id: "QLE_LINK_LABEL" }),
        to: memberScreenerUrl,
        onClick: () => {
          learnMoreClick();
        }
      },
      formatMessage({ id: "LEARN_MORE" })
    )),
    /* @__PURE__ */ React.createElement(
      BackgroundImage,
      {
        alt: "",
        src: handleStaticAsset(
          "ADD_DEPENDENT_BANNER" /* ADD_DEPENDENT_BANNER */
        ),
        width: "35%"
      }
    )
  );
};

// src/components/league-family-education-banner/league-family-education-banner.component.tsx
import React2 from "react";
import {
  Flex as Flex2,
  Box as Box2,
  HeadingFour as HeadingFour2,
  BodyOneSecondary,
  Link as Link2,
  Image,
  VisuallyHidden
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2,
  PRODUCT_AREA as PRODUCT_AREA2
} from "@leagueplatform/analytics";
function learnMoreClick2(url) {
  trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA2.WALLET,
    screen_name: "dependents settings",
    detail: "League family - learn more",
    link: url,
    text_detail: "League family education banner",
    text_sub_detail: "League family help centre article"
  });
}
var LeagueFamilyEducationBanner = ({
  url
}) => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ React2.createElement(
    Flex2,
    {
      as: "section",
      width: 1,
      marginBottom: "oneAndHalf",
      borderStyle: "solid",
      borderWidth: "thin",
      borderRadius: "medium",
      justifyContent: "space-between",
      padding: "two"
    },
    /* @__PURE__ */ React2.createElement(Box2, { width: "70%" }, /* @__PURE__ */ React2.createElement(HeadingFour2, { marginBottom: "half", as: "h2" }, formatMessage({
      id: "LEAGUE_FAMILY_EDUCATION_BANNER_HEADER"
    })), /* @__PURE__ */ React2.createElement(BodyOneSecondary, { marginBottom: "oneAndHalf" }, formatMessage({
      id: "LEAGUE_FAMILY_EDUCATION_BANNER_SUBHEADER"
    })), /* @__PURE__ */ React2.createElement(
      Link2,
      {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => learnMoreClick2(url)
      },
      formatMessage({ id: "LEARN_MORE" }),
      /* @__PURE__ */ React2.createElement(VisuallyHidden, null, formatMessage({ id: "LEARN_MORE_LEAGUE_FAMILY" }))
    )),
    /* @__PURE__ */ React2.createElement(
      Image,
      {
        src: handleStaticAsset2(
          "LEAGUE_FAMILY_EDUCATION_BANNER" /* LEAGUE_FAMILY_EDUCATION_BANNER */
        ),
        width: 128,
        height: 128,
        alt: ""
      }
    )
  );
};

// src/components/league-family-pending-invite-banner/league-family-pending-invite-banner.component.tsx
import * as React3 from "react";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import {
  BodyOne as BodyOne2,
  Box as Box3,
  Flex as Flex3,
  Image as Image2,
  Link as Link3,
  SubtitleOne
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
function LeagueFamilyPendingInviteBanner({
  title,
  description,
  linkText,
  linkUrl
}) {
  const hasLink = linkText && linkUrl;
  return /* @__PURE__ */ React3.createElement(
    Box3,
    {
      as: "section",
      width: 1,
      marginBottom: "oneAndHalf",
      borderRadius: "small",
      backgroundColor: "highlight.background.subdued",
      padding: "one",
      paddingInlineStart: "three"
    },
    /* @__PURE__ */ React3.createElement(Flex3, { alignItems: "center" }, /* @__PURE__ */ React3.createElement(
      Image2,
      {
        src: handleStaticAsset3("CIRCLE_INFO_ICON" /* CIRCLE_INFO_ICON */),
        alt: "",
        size: 20,
        marginInlineStart: "minusTwo",
        position: "absolute"
      }
    ), /* @__PURE__ */ React3.createElement(SubtitleOne, { as: "h2", marginBottom: "quarter" }, title)),
    /* @__PURE__ */ React3.createElement(BodyOne2, null, description),
    hasLink && /* @__PURE__ */ React3.createElement(Link3, { as: RouterLink, to: linkUrl, fontSize: "body2", marginTop: "quarter" }, linkText)
  );
}

// src/index.tsx
initModule();
export {
  AddDependentBanner,
  LeagueFamilyEducationBanner,
  LeagueFamilyPendingInviteBanner
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/dependents'] = window.leagueSDKsPresent['@leagueplatform/dependents'] || [];
    window.leagueSDKsPresent['@leagueplatform/dependents'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/dependents'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/dependents module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map